import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Features from '../pages/features/page';
import Pricing from '../pages/pricing/page';
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import CertificateLookup from '../pages/certificate-lookup/page';
import NotFound from '../pages/NotFound';
import AdminDashboard from '../pages/admin-dashboard/page';
import SuperAdminDashboard from '../pages/super-admin-dashboard/page';
import StudentDashboard from '../pages/student-dashboard/page';
import AdminCertificates from '../pages/admin/certificates/page';
import AdminBulkIssue from '../pages/admin/bulk-issue/page';
import AdminTemplates from '../pages/admin/templates/page';
import AdminStudents from '../pages/admin/students/page';
import AdminAnalytics from '../pages/admin/analytics/page';
import AdminPayments from '../pages/admin/payments/page';
import AdminSettings from '../pages/admin/settings/page';
import SuperAdminCompanies from '../pages/super-admin/companies/page';
import SuperAdminRevenue from '../pages/super-admin/revenue/page';
import ProtectedRoute from '../components/feature/ProtectedRoute';
import { lazy } from 'react';

const AdminSettlement = lazy(() => import('../pages/admin/settlement/page'));
const SuperAdminCommission = lazy(() => import('../pages/super-admin/commission/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/features',
    element: <Features />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/certificate-lookup',
    element: <CertificateLookup />
  },
  {
    path: '/admin-dashboard',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminDashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/certificates',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminCertificates />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/bulk-issue',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminBulkIssue />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/templates',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminTemplates />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/students',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminStudents />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/analytics',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminAnalytics />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/payments',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminPayments />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/settings',
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminSettings />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/settlement',
    element: <AdminSettlement />,
  },
  {
    path: '/super-admin-dashboard',
    element: (
      <ProtectedRoute requiredRole="super_admin">
        <SuperAdminDashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '/super-admin/companies',
    element: (
      <ProtectedRoute requiredRole="super_admin">
        <SuperAdminCompanies />
      </ProtectedRoute>
    )
  },
  {
    path: '/super-admin/revenue',
    element: (
      <ProtectedRoute requiredRole="super_admin">
        <SuperAdminRevenue />
      </ProtectedRoute>
    )
  },
  {
    path: '/super-admin/commission',
    element: <SuperAdminCommission />,
  },
  {
    path: '/student-dashboard',
    element: (
      <ProtectedRoute requiredRole="student">
        <StudentDashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
